import { render, staticRenderFns } from "./oumeiplan.vue?vue&type=template&id=66614884&scoped=true&"
import script from "./oumeiplan.vue?vue&type=script&lang=js&"
export * from "./oumeiplan.vue?vue&type=script&lang=js&"
import style0 from "./oumeiplan.vue?vue&type=style&index=0&id=66614884&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66614884",
  null
  
)

export default component.exports